import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Headphones, Search, MapPin, CreditCard, FileText, MoreHorizontal, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useApiQuery } from "../lib/useApiQuery";
import { PageHeader } from "../components/PageHeader";

const ICONS = { order: FileText, address: MapPin, payment: CreditCard, other: MoreHorizontal };
const COLORS = { order: "#FF3D5A", address: "#3F8CFF", payment: "#00B894", other: "#6B7280" };

export default function Help() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  const { data } = useApiQuery(["help-content"], "/help/content");
  const cats = data?.categories || [];
  const faqsAll = data?.faqs || [];

  const contactSupport = async () => {
    try {
      const c = await api("/support/contact");
      navigate(`/chat/${c.user_id}`);
    } catch (e) {
      toast.error(e.message || "تعذّر فتح الدعم");
    }
  };

  const faq = faqsAll.filter((f) => !q || (f.q || "").includes(q) || (f.a || "").includes(q));

  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="المساعدة" />
      <div className="flex flex-col items-center text-center mt-2 mb-5">
        <div className="w-16 h-16 rounded-2xl bg-[#FFE5EA] flex items-center justify-center mb-3"><Headphones size={30} className="text-[#FF3D5A]" /></div>
        <h2 className="text-xl font-black text-[#161629]">كيف يمكننا مساعدتك؟</h2>
      </div>
      <div className="relative mb-5">
        <Search size={18} className="absolute top-3.5 end-4 text-[#9CA3AF]" />
        <input data-testid="help-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="بحث" className="w-full bg-[#F0F2FA] rounded-2xl ps-4 pe-11 py-3 outline-none text-right" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        {cats.map((c) => {
          const Icon = ICONS[c.key] || MoreHorizontal;
          return (
            <button key={c.key} data-testid={`help-cat-${c.key}`} onClick={contactSupport} className="text-right p-4 rounded-2xl border border-[#E8EAF2] bg-white hover:shadow-sm transition">
              <Icon size={22} style={{ color: COLORS[c.key] || "#6B7280" }} />
              <p className="font-black text-[#161629] mt-2">{c.title}</p>
              <p className="text-xs text-[#6B7280] mt-1 leading-5">{c.desc}</p>
            </button>
          );
        })}
      </div>
      <h3 className="font-black text-[#161629] mt-6 mb-2">الأسئلة الشائعة</h3>
      <div className="space-y-2">
        {faq.map((f, i) => (
          <div key={i} className="bg-white rounded-2xl border border-[#E8EAF2] overflow-hidden">
            <button data-testid={`faq-${i}`} onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-4 text-right">
              <span className="font-bold text-sm text-[#161629] flex-1">{f.q}</span>
              <ChevronDown size={18} className={`text-[#9CA3AF] transition ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && <p className="px-4 pb-4 text-sm text-[#6B7280] leading-6">{f.a}</p>}
          </div>
        ))}
        {faq.length === 0 && <p className="text-center text-sm text-[#6B7280] py-6">لا نتائج — تواصل مع الدعم مباشرة</p>}
      </div>
      <button data-testid="help-contact-support" onClick={contactSupport} className="w-full h-14 rounded-2xl bg-[#FF3D5A] text-white font-black mt-6">تواصل مع الدعم</button>
    </div>
  );
}
